import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { getPaymentLinkDetails } from "../../services/payment-link.services";
import { IPaymentLinkDetails } from "../../types/payment-link.types";
import { IApiResponse } from "../../../../utils/types/api-response";

export function useGetPaymentLinkDetails(
    ref: string,
    code?: string,
    enabled?: boolean
) {
    return useQuery<
        IApiResponse<IPaymentLinkDetails>,
        AxiosError<IApiResponse<IPaymentLinkDetails>>
    >({
        queryKey: ["payment-link-details", ref],
        queryFn: () => getPaymentLinkDetails(ref, code),
        enabled,
    });
}
